export const SAASBRANDNAME: Record<string, string> = {
  AGRITECH: 'agritech',
  AGRODRONE: 'agrodrone',
  ALLYFARM: 'allyfarm',
  ANDRIANIFARM: 'andrianiFarm',
  ANALYTICS: 'analytics',
  ANALYTICSBARILLA: 'analyticsbarilla',
  ARVAMAP: 'arvamap',
  BARILLA: 'barilla',
  CEREALDOCKS: 'cerealdocks',
  CIECH: 'ciech',
  COBO: 'cobo',
  COLUSSI: 'colussi',
  DAZEFARM: 'dazefarm',
  DIAMANT: 'diamant',
  GALLO: 'gallo',
  GAVIOGROUP: 'ath7',
  GFARM: 'gfarm',
  GRANLATTE: 'granlatte',
  GRASCAN: 'grascan',
  GREENSPEC: 'greenspec',
  HUBFARM: 'hubfarm',
  IFARMS: 'ifarms',
  IRRIGAZIONEVENETA: 'irrigazioneveneta',
  JINGOLD: 'jingold',
  KRUKOWIAK: 'krukowiak',
  LACTALIS: 'lactalis',
  LANDINI: 'landini',
  LANDLAB: 'landlab',
  LENS: 'lens',
  MASCHIOGASPARDO: 'mf1',
  MCCORMICK: 'mccormick',
  OLIVETTI: 'olivetti',
  PIONEERFIELDS: 'pioneerfields',
  PROTERRA: 'proterra',
  ROQUETTE: 'roquette',
  ROVENSA: 'rovensa',
  SDF: 'sdf',
  TAFEDIGIAG: 'tafedigiag',
  TAFEDIGIAGDEV: 'tafedigiagdev',
  TOMATOFARM: 'tomatofarm',
  TURBOFARM: 'turbofarm',
  UNIA: 'unia',
  VERDEVIEW: 'verdeview',
  VISIOFARM: 'visiofarm',
  VITERRA: 'viterra',
  XAGRI: 'xagri',
  XFARM: 'xfarm',
  CUADERNODIGITAL: 'cuadernodigital',
  SAMASZPROFARM: 'samaszprofarm',
};
